import _ from 'lodash'
import { MutationTree } from 'vuex'
import { ProductState } from '@/modules/product/store'
import { ProductPagination, ProductPaginationParams, Product } from '@/modules/product'
import UnigestLanguage from '@/modules/product/model/UnigestLanguage';
import ProductTranslation from '@/modules/product/model/ProductTranslation';

export enum MutationTypes {
    SetProductPagination = 'product/pagination/set',
    SetProductPaginationParams = 'product/pagination/params/set',
    SetLoadingPagination = 'product/pagination/loading/set',
    SetCurrentProduct  = 'product/current/set',
    SetCurrentLocale = 'product/locale/current/set',
    UpdateProductTranslationField = 'product/translation/field/update',
    UpdateProductField = 'product/current/field/update',
    ShowProductImage = 'product/image/show',
    ShowSaveConfirm = 'product/save/confirm/show',
    SetUnigestLanguages = 'unigest/languages/set',
    AddProductTranslation = 'product/translation/add',
}

const mutations: MutationTree<ProductState> = {

    /**
     * Establece la paginación de productos actualmente mostrada al usuario
     */
    [MutationTypes.SetProductPagination]: (state, pagination: ProductPagination) => state.pagination = pagination,

    /**
     * Establece si se esta cargando alguna paginación
     */
    [MutationTypes.SetLoadingPagination]: (state, loading: boolean) => state.loadingPagination = loading,

    /**
     * Establece los parámetros de paginación
     */
    [MutationTypes.SetProductPaginationParams]: (state, params: ProductPaginationParams) => {
        state.paginationParams = params
    },

    /**
     * Permite establecer el producto actualmente en edición
     */
    [MutationTypes.SetCurrentProduct]: (state, product: Product) => state.currentProduct = product,

    /**
     * Establece el localismo actualmente seleccionado por el usuario
     */
    [MutationTypes.SetCurrentLocale]: (state, locale: string) => state.currentLocale = locale,

    /**
     * Actualiza uno de los campos de la traducción actualmente en edición
     */
    [MutationTypes.UpdateProductTranslationField]: (state, payload: {path: string, value: string}) => {
        const product = _.clone(state.currentProduct)
        let translation = product.translate(state.currentLocale)

        if (!translation) {
            throw new Error(`No existe la traducción en el idioma ${state.currentLocale}`)
        }

        translation = _.set(translation, payload.path, payload.value)
        product.addTranslation(translation)

        state.currentProduct = product
    },

    /**
     * Actualiza un campo del producto actual
     */
    [MutationTypes.UpdateProductField]: (state, payload: {path: string, value: any}) => {
        const product = _.clone(state.currentProduct)
        state.currentProduct = _.set(product, payload.path, payload.value)
    },

    [MutationTypes.ShowProductImage]: (state, show: boolean) => state.showProductImage = show,

    [MutationTypes.ShowSaveConfirm]: (state, show: boolean) => state.saveConfirm = show,

    [MutationTypes.SetUnigestLanguages]: (state, languages: UnigestLanguage[]) => state.unigestLanguages = languages,

    [MutationTypes.AddProductTranslation]: (state, locale: string) => {
        state.currentProduct.addTranslation(new ProductTranslation(locale))
    },
}

export default mutations
